/**
 * @generated SignedSource<<4c021c6a1ed1e30b20e3b67fb4ea22e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null | undefined;
  readonly status: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment";
};
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "f4093e7916c35c0c1b9141fd35c3dbe3";

export default node;
